<template>
  <div class="flex-fill">
    <div >
      <div v-html="question.text"></div>

      <div class=" p-2">
        <media-preview v-if="question.media_id" :id="question.media_id" v-model="question.media"/>
      </div>

      <div>
        <ul v-if="question.type == 'checkbox'">
          <li v-for="c in choices" :key="c.id">
            <div class="p-1">
              <span v-show="showAnswer && c.is_answer" class="text-success">
                <i class="far fa-2x pr-2 question-icon fa-check-square"></i>
              </span>

              <span v-show="!showAnswer || !c.is_answer">
                <i class="far fa-2x pr-2 question-icon fa-square"></i>
              </span>

              <span>{{ c.label }}</span>
              <media-preview v-if="c.media_id" :id="c.media_id" v-model="c.media" style="margin-left:1.5rem"/>
            </div>
          </li>
        </ul>
        <ul v-if="question.type == 'radio'">
          <li v-for="c in choices" :key="c.id">
            <div class="p-1">
              <span v-show="showAnswer && c.is_answer" class="text-success">
                <i class="far fa-2x pr-2 question-icon fa-check-circle"></i>
              </span>

              <span v-show="!showAnswer || !c.is_answer">
                <i class="far fa-2x pr-2 question-icon fa-circle"></i>
              </span>

              <span>{{ c.label }}</span>
              <media-preview v-if="c.media_id" :id="c.media_id" v-model="c.media" style="margin-left:1.5rem"/>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import mediaPreview from '@/components/common/media/object-media-preview.vue'

export default {
  components:{
    mediaPreview
  },
  props:{
    question: {type:Object, required: true},
    showAnswer: { type: Boolean, default: false }
  },
  data(){
    return {
      showChoiceAnswer: false
    }
  },
  computed:{
    componentId(){
      return this._uid
    },
    choices(){
      return _.sortBy(this.question.choices, ['order'])
    }
  },
  watch:{
    showAnswer(val){
      this.showChoiceAnswer = val
    }
  }
}
</script>

<style lang="scss" scoped>
.question-label{
  margin-left: 1rem;
  min-width:1.25rem;
  white-space: nowrap !important;
}

.question-content{
  padding: 0 .5rem;
}

.question-icon{
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/print/question.vue